import React from 'react'

import { Flex, TextField } from 'components/ds'
import style from '../index.module.css'

type Props = {
  searchValue: string
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const TagSearchTextField = ({ searchValue, onSearch }: Props) => {
  return (
    <Flex
      direction="column"
      width="100%"
      className={style.TagFilterSearch_Container}
    >
      <Flex
        width="100%"
        direction="column"
        pt="4"
        className={style.TagFilterSearchField}
      >
        <TextField.Root
          value={searchValue}
          onChange={onSearch}
          placeholder="Search tags.."
          type="text"
        />
      </Flex>
    </Flex>
  )
}

export default TagSearchTextField
